module.exports = __webpack_public_path__ + "img/health-tpsalud-bg.7e58f83a.png";